export default __webpack_public_path__ + "static/media/ic_sahrawi_arab_democratic_republic.aba927cb.svg";